import tmsApi from './../../api/tmsApi';
import helper from './../helper';

const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      location: 'LOADING',
    },
    locations: [],
    detailData: null,
    detailDataId: null,
    dataLoaded: false,
    count_info: {
      all: 0,
    },
    query: {
      search: '',
      page: {
        number: 1,
        count: 10,
      },
      sort: {
        by: 'NAME',
        direction: 'ASC',
      },
      company_id: null,
      parent_id: null,
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.locations.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.locations.push(data);
    },
    REPLACE_DATA(state, locations) {
      state.locations.splice(0, state.locations.length, ...locations);
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.page.number = 1;
      query.page.count = 10;
      query.sort.by = 'NAME';
      query.sort.direction = 'ASC';
      query.company_id = null;
      query.sort.parent_id = null;
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count = 10) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_QUERY_COMPANY_ID(state, companyId) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.company_id = companyId;
    },
    SET_QUERY_PARENT_ID(state, parentId) {
      state.query.parent_id = parentId;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
      }, this);
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    SET_DATA_LOCATION({ dataState }, state) {
      dataState.location = state;
    },
  },
  getters: {
    locations(state) {
      return state.locations;
    },
    count_all(state) {
      return state.count_info.all;
    },
    query_count(state) {
      return state.query.page.count;
    },
    query_page(state) {
      return state.query.page.number;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    loadLocation(state) {
      return state.dataState.location;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token, 'shipment_md');
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const parentId = createInputParam(state.query, 'parent_id', false);
      let searchQuery = '';
      if (typeof state.query.search === 'string' && state.query.search.trim().length) {
        const q = state.query.search.trim();
        searchQuery = `query: "${q}"`;
      }
      const query = `
        {
          locations(
            ${companyId}
            ${parentId}
            ${searchQuery}
            offset: ${offset},
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction},
            },
          ) {
              id
              code
              name
              latitude
              longitude
              created_at
              company {
                id
                name
              }
              geometry {
                type
                coordinates
              }
              metadata
          }
        }
      `;
      commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_LOCATION', 'LOADING');
      return api(query, 'locations').then(({ data }) => {
        const { locations } = data;
        commit('REPLACE_DATA', locations);
        commit('SET_DATA_LOADED');
        commit('SET_DATA_LOCATION', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_LOCATION', 'ERROR');
      });
    },
    LOAD_INFO({ state, commit, rootState }) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token, 'shipment_md');
      const { query: { search } } = state;
      const companyId = createInputParam(state.query, 'company_id', false);
      const parentId = createInputParam(state.query, 'parent_id', false);
      const query = `
        {
          location_info(
            query: "${search}"
            ${companyId}
            ${parentId}
          ) {
            count
          }
        }
      `;
      return api(query, 'location_info').then(({ data }) => {
        const { location_info } = data;
        commit('SET_COUNT_INFO', location_info);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_INFO');
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { query: { search } } = state;
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const parentId = createInputParam(state.query, 'parent_id', false);
      const query = `
        {
          locations: find_locations(
            query: "${search}",
            ${companyId},
            ${parentId},
            offset: ${offset},
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction},
          }) {
              id
              code
              name
              latitude
              longitude
              created_at
              company {
                id
                name
              }
              geometry {
                type
                coordinates
              }
              metadata
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      return api(query, 'find_locations').then(({ data }) => {
        const { locations } = data;
        locations.forEach((location) => {
          commit('ADD_DATA_ON_LIST', location);
        }, this);
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('ADD_ERROR', 'FIND_DATA');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token, 'shipment_md');
      const { detailDataId } = state;
      const query = `
        {
          location(id: ${detailDataId}) {
            id
            code
            name
            latitude
            longitude
            created_at
            company {
              id
              name
            }
            geometry {
              type
              coordinates
            }
            metadata
          }
        }
      `;
      return api(query, 'location').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.location);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    SEARCH_ADDRESS({ rootState, commit }, address) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token, 'shipment_md');
      const query = `
        {
          found: search_address(query: "${address}") {
            formatted_address
            geometry {
              location {
                lat
                lng
              }
            }
          }
        }
      `;
      return api(query, 'search_address').then(({ data }) => {
        const { found } = data;
        return found;
      }).catch(() => {
        commit('ADD_ERROR', 'SEARCH_ADDRESS');
      });
    },
    REVERSE_GEOCODE({ rootState, commit }, latlong) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token, 'shipment_md');
      const query = `
        {
          found: reverse_geocode(query: "${latlong}") {
            formatted_address
            geometry {
              location {
                lat
                lng
              }
            }
          }
        }
      `;
      return api(query, 'reverse_geocode').then(({ data }) => {
        const { found } = data;
        return found;
      }).catch(() => {
        commit('ADD_ERROR', 'REVERSE_GEOCODE');
      });
    },
    CREATE_DATA({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const { geometry, metadata } = payloads;
      const code = createInputParam(payloads, 'code');
      const name = createInputParam(payloads, 'name');
      const type = createInputParam(payloads, 'type');
      const longitude = createInputParam(payloads, 'longitude');
      const latitude = createInputParam(payloads, 'latitude');
      const companyId = createInputParam(payloads, 'company_id', false);
      const radius = createInputParam(metadata, 'radius', 'false');
      let { coordinates } = geometry;
      if (geometry.type !== 'Point') {
        coordinates = new Array(coordinates);
      }
      const mutation = ` mutation {
          location: create_location(input: {
            ${code}
            ${name}
            ${type}
            ${longitude}
            ${latitude}
            ${companyId}
            metadata: {
              ${radius}
            }
            geometry: {
              type: "${geometry.type}"
              coordinates: ${JSON.stringify(coordinates)}
            }
          }) {
            id
            code
            name
            latitude
            longitude
            created_at
            company {
              id
              name
            }
            geometry {
              type
              coordinates
            }
            metadata
          }
        }
      `;
      return api(mutation, 'create_location').then(({ data }) => {
        const { location } = data;
        commit('SET_DETAIL_DATA', location);
        return location;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
      });
    },
    UPDATE_DATA({ state, commit, rootState }, payloads) {
      let { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const { geometry, metadata } = payloads;
      const code = createInputParam(payloads, 'code');
      const name = createInputParam(payloads, 'name');
      const type = createInputParam(payloads, 'type');
      const longitude = createInputParam(payloads, 'longitude');
      const latitude = createInputParam(payloads, 'latitude');
      const companyId = createInputParam(payloads, 'company_id', false);
      const radius = createInputParam(metadata, 'radius', 'false');
      let { coordinates } = geometry;
      if (geometry.type !== 'Point') {
        coordinates = new Array(coordinates);
      }

      if (Object.prototype.hasOwnProperty.call(payloads, 'id')) {
        detailDataId = payloads.id;
      }

      const mutation = ` mutation {
        location: update_location(id: ${detailDataId}, input: {
          ${code}
          ${name}
          ${type}
          ${longitude}
          ${latitude}
          ${companyId}
          metadata: {
            ${radius}
          }
          geometry: {
            type: "${geometry.type}"
            coordinates: ${JSON.stringify(coordinates)}
          }
        }) {
          id
          code
          name
          latitude
          longitude
          created_at
          company {
            id
            name
          }
          geometry {
            type
            coordinates
          }
          metadata
        }
      }
      `;
      return api(mutation, 'update_location').then(({ data }) => {
        const { location } = data;
        commit('SET_DETAIL_DATA', location);
        return location;
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    DELETE_DATA({ state, rootState, commit }, locationId) {
      const id = !locationId ? state.detailDataId : locationId;
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const mutation = `mutation {
        deleted: delete_location(id: ${id})
      }`;
      return api(mutation, 'delete_location').then(({ data }) => {
        const { deleted } = data;
        return deleted;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    GET_LOCATIONS_BY_COMPANYID({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token, 'shipment_md');
      const { company_id: companyId } = payloads;
      const query = `
        {
          locations(company_id: ${companyId}) {
            id
            code
            name
          }
        }
      `;

      return api(query, 'get_locations_by_companyid')
        .then(({ data }) => (data.locations))
        .catch(() => {
          commit('ADD_ERROR', 'GET_LOCATIONS_BY_COMPANYID');
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/shipment_md/locations.js